import { Injectable } from '@angular/core';
import moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class BlockService {
  AutoIndex = null
  startDate: Date
  endDate: Date
  duration: number
  constructor(private http:HttpClient, public ls :LoginService) { }


  
  calculateDuration(startDate: Date, endDate: Date): number {
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);
    const duration = endMoment.diff(startMoment);
    const durationInMinutes = moment.duration(duration).asMinutes();

    return durationInMinutes;
  }

  addBlock(block){
    return this.http.post('/api/block',block)
  }


  setBlock({AutoIndex,aptlength,aptTime,blockEndTime}){
    this.AutoIndex=AutoIndex
    this.duration=aptlength
    this.startDate=new Date(aptTime);
    this.endDate=new Date(blockEndTime)
  }

  
  async delete(): Promise<boolean>{
    if (this.AutoIndex == null) {
      throw new Error('AutoIndex is not set.');
    }
  
    try {
      await this.http.delete(`/api/block/${this.AutoIndex}`).toPromise();
      this.resetService();
      return true;
    } catch (error) {
      console.error('Error deleting block:', error);
      throw error;
    }
  }


  
  
  async updateBlock(block): Promise<any>{
    if (block.AutoIndex == null) {
      throw new Error('AutoIndex is not set.');
    }
  
    try {
      return this.http.put(`/api/block`,block).toPromise();
     
      
    } catch (error) {
      console.error('Error update event:', error);
      throw error;
    }
  }

  
private resetService() {
  this.AutoIndex = null;
  this.startDate = null;
  this.endDate = null;
  this.duration = null;
}

}
